export class ResultsPageReadModel
{
    UserId: number;

    AlternativesListId: number;
    ScoringEnabled: boolean;

    GoalName: string;
    GoalCriterionId: number;

    ViewDefs: ViewDefReadModel[];
    ViewDefId: string | null;

    WeightsSets: WeightsSetReadModel[];
    WeightsSetId: number | null;

    ScoringPanels: ScoringPanelReadModel[];
    ScoringSurveyId: number | null;
    ScoringProjectUserId: number | null;

    Criteria: CriterionReadModel[];
    CriterionId: number;

    Alternatives: AlternativeReadModel[]
    Attributes: AttributeReadModel[];
    Weights: CriterionWeightReadModel[];
}


export class AlternativeReadModel
{
    Id: string;
    Name: string;
    Description: string;
    StatusName: string;
    Created: Date;
    Modified: Date | null;
    Attributes: AlternativeAttributeValueReadModel[];
    Criteria: AlternativeCriterionValuesReadModel[];
}

export class AlternativeAttributeValueReadModel
{
    AttributeId: number;
    Value: any;
}

export class AlternativeCriterionValuesReadModel
{
    CriterionId: number;
    Value: number | null;
    Score: number | null;
    Rank: number | null;
}


export class AttributeReadModel 
{
    Id: number;
    Name: string;
    Section: string;
    Description: string;
    GridFieldType: string;

    IsMultivalue: boolean;

    Format: string;

    IsNumeric: boolean;
    IsDate: boolean;

    IsList: boolean;
    IsManual: boolean;
    IsCalculated: boolean;
}

export class ViewDefReadModel 
{
    Id: string;
    Name: string
}

export class CriterionReadModel
{
    Id: number;
    ParentId: number | null;
    Name: string;
    IsParent: boolean;
    BottomIds: number[];
}

export class CriterionWeightReadModel
{
    CriterionId: number;
    LocalWeight: number;
    GlobalWeight: number;
}

export class WeightsSetReadModel
{
    Id: number;
    Name: string;
}

export class ScoringPanelReadModel
{
    Id: number;
    Name: string;
}

export class ScoringPanelistsReadModel 
{
    Panelists: ScoringPanelistReadModel[];
}

export class ScoringPanelistReadModel 
{
    Id: number;
    Name: string;
    Email: string;
}

export class AlternativeAttributeValueChangeReadModel
{
    Id: string;
    Name: string;
    NewValue: number | null;
    OldValue: number | null;
}